import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

// Post-logout landing per docs/ui/operator-ui-tds.md §7. Reached after the
// three-step force-logout sequence completes (WS close → revoke → clear).

export function GoodbyePage() {
  const { t } = useTranslation('admin');
  return (
    <div className="flex h-screen items-center justify-center p-6">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold">{t('goodbye.title')}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{t('goodbye.body')}</p>
        <div className="mt-6">
          <Button onClick={() => (window.location.href = '/login')}>{t('goodbye.signIn')}</Button>
        </div>
      </div>
    </div>
  );
}
